import { browser } from '$app/environment';
import { loadBundledSewMimicExports, type BundledWasmExports } from './wasm-loader';

export type SewMimicModule = BundledWasmExports;

let moduleInstance: SewMimicModule | null = null;
let modulePromise: Promise<SewMimicModule> | null = null;

export interface SewMimicInitOptions {
	/** Optional explicit URL for the compiled wasm asset. */
	wasmUrl?: string;
	/** Enable extra wasm-side logging if supported in future builds. */
	debug?: boolean;
}

/**
 * Lazily load the SEW-Mimic wasm module. Subsequent calls return the cached instance.
 */
export async function loadSewMimicModule(options: SewMimicInitOptions = {}): Promise<SewMimicModule> {
	if (!browser) {
		throw new Error('SEW-Mimic runtime is only available in the browser environment');
	}

	if (moduleInstance) {
		return moduleInstance;
	}

	if (!modulePromise) {
		modulePromise = (async () => {
			if (options.wasmUrl) {
				// Allow advanced builds to provide a pre-hosted wasm-bindgen bundle.
				const override = await import(/* @vite-ignore */ options.wasmUrl);
				moduleInstance = override as BundledWasmExports;
				return moduleInstance;
			}

			const mod = await loadBundledSewMimicExports();
			moduleInstance = mod;
			return mod;
		})().catch((error) => {
			modulePromise = null;
			throw error;
		});
	}

	return modulePromise;
}

export function getSewMimicModule(): SewMimicModule | null {
	return moduleInstance;
}

export function resetSewMimicModule(): void {
	moduleInstance = null;
	modulePromise = null;
}
